export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getBusinessCooperationList: function getBusinessCooperationList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/business/cooperation",
        method: "get",
        params: data
      });
    },
    setBusinessCooperation: function setBusinessCooperation() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/business/cooperation",
        method: "post",
        data: data
      });
    }
  };
});